const PROPRIETARY_FORMAT_VIDEO_FILE = [
  {
    ext: '.mpvc',
    desc: 'Honeywell Security MAXPRO - used by cameras',
  },
] as const;

export default PROPRIETARY_FORMAT_VIDEO_FILE;
